import "./index.scss";
import { GeneralSmallLocation } from "@wise-emotions/react-icons";
import { isValidString } from "utilities/utils";
import IconWrap from "components/Icon/IconWrap";
import React from "react";
import SocialShare from "components/SocialShare";

interface Props {
  date?: string;
  location?: string;
}

export default function PostShareAndInfo({ date, location }: Props) {
  return (
    <div className="PostShareAndInfo row justify-content-center">
      {isValidString(date) && (
        <div className="PostShareAndInfo__col col-12 col-md-auto">{date}</div>
      )}
      {isValidString(location) && (
        <div className="PostShareAndInfo__col col-12 col-md-auto">
          <IconWrap>
            <GeneralSmallLocation />
          </IconWrap>{" "}
          {location}
        </div>
      )}
      <div className="PostShareAndInfo__col col-12 col-md-auto order-md-first">
        <SocialShare
          socialActive={["facebook", "twitter", "linkedin"]}
          classIcos="PostShareAndInfo__social-icon"
        />
      </div>
    </div>
  );
}
